import { HttpContextToken } from '@angular/common/http';

/**
 * Marca una petición cuyo 403 es una RESPUESTA esperada, no un error que haya
 * que avisar.
 *
 * Existe por `GET /auth/check-subscription`: con la suscripción vencida responde
 * 403 `subscription_invalid`, y eso es justo lo que se quiere saber, no un fallo.
 * Sin esta marca, `authInterceptor` sacaba el aviso «Tu suscripción no está
 * activa…» en cada navegación por las pantallas de solo lectura, que ya enseñan
 * su propio aviso con el enlace para renovar.
 */
export const SKIP_FORBIDDEN_NOTICE = new HttpContextToken<boolean>(() => false);
